











import {Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class SimpleTag extends Vue {

    @Prop({default: 'green'}) color: string;
    @Prop({default: false }) active: boolean;
    @Prop({ default: true }) clickable: boolean;

    close(event: Event) {
        event.stopPropagation();
        this.$emit('close')
    }

    toggle() {
        this.$emit('click');
    }
}
